/*

import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import ContactForm from './Contact';
import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = process.env.REACT_APP_ENQUIRY_SUPABASE_URL;
const SUPABASE_KEY = process.env.REACT_APP_ENQUIRY_SUPABASE_SERVICE_ANON_KEY;
const supabase = createClient(SUPABASE_URL, SUPABASE_KEY);

// 🔹 YOUR ORIGINAL HARDCODED ARTICLES
export const articleContent = [  ];

const ArticleDetailPage = () => {
  const [article, setArticle] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadArticle = async () => {
      const params = new URLSearchParams(window.location.search);
      const articleId = parseInt(params.get('id'));

      // 1️⃣ Try hardcoded
      const localArticle = articleContent.find(a => a.id === articleId);
      if (localArticle) {
        setArticle(localArticle);
        setLoading(false);
        return;
      }

      // 2️⃣ Try Supabase
      const { data } = await supabase
        .from('articles')
        .select('*')
        .eq('id', articleId)
        .single();

      if (data) {
        setArticle({
          title: data.title,
          fullContent: data.description
        });
      }

      setLoading(false);
    };

    loadArticle();
  }, []);

  if (loading) return <p className="text-center my-5">Loading...</p>;

  if (!article) {
    return (
      <div className="container my-5">
        <div className="card shadow-sm border-0 p-4">
          <h2 className="text-center" style={{ color: '#FF5733' }}>
            Article Not Found
          </h2>
          <p className="text-center">
            The requested guide does not exist. Please check your URL query parameter (e.g., ?id=1).
          </p>
          <Link to="/news-page" className="btn btn-outline-dark mt-4">
            ← Back to News & Guides
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div>
      
      <nav className="navbar navbar-expand-lg navbar-light bg-dark shadow-sm">
        <div className="container">
          <Link to="/" className="navbar-brand">
            <img src="/image/Glogo.png" alt="Company Logo" style={{ height: '50px' }} />
          </Link>
        </div>
      </nav>

      
      <div className="container my-5">
        <div className="row d-flex align-items-stretch">
          <div className="col-lg-7 mb-4">
            <div className="card shadow-sm border-0 p-4 h-100">
              <h2 className="text-center mb-4" style={{ color: '#de1829ff' }}>
                {article.title}
              </h2>

              <div
                className="article-body"
                style={{ lineHeight: '1.6' }}
                dangerouslySetInnerHTML={{ __html: article.fullContent }}
              />

              <Link to="/news-page" className="btn btn-outline-dark mt-4">
                ← Back to News & Guides
              </Link>
            </div>
          </div>

          <div className="col-lg-5">
            <div className="card shadow-sm border-0 h-100">
              <ContactForm />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ArticleDetailPage;*/



import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import ContactForm from './Contact';
import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL =
  process.env.REACT_APP_ENQUIRY_SUPABASE_URL;
const SUPABASE_KEY =
  process.env.REACT_APP_ENQUIRY_SUPABASE_ANON_KEY ||
  process.env.REACT_APP_ENQUIRY_SUPABASE_SERVICE_ANON_KEY
const supabase = SUPABASE_URL && SUPABASE_KEY ? createClient(SUPABASE_URL, SUPABASE_KEY) : null;

const ArticleDetailPage = () => {
  const [article, setArticle] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadArticle = async () => {
      if (!supabase) {
        console.error(
          'Missing Supabase env vars. Set REACT_APP_ENQUIRY_SUPABASE_URL and REACT_APP_ENQUIRY_SUPABASE_ANON_KEY (or fallback REACT_APP_SUPABASE_URL / REACT_APP_SUPABASE_ANON_KEY).'
        );
        setLoading(false);
        return;
      }

      const params = new URLSearchParams(window.location.search);
      const articleId = parseInt(params.get('id'));

      // Fetch the article from Supabase
      const { data } = await supabase
        .from('articles')
        .select('*')
        .eq('id', articleId)
        .single();  // Ensure only one article is returned

      if (data) {
        setArticle({
          title: data.title,
          fullContent: data.description,  // Store the full content (with HTML)
        });
      }

      setLoading(false);
    };

    loadArticle();
  }, []);

  if (loading) return <p className="text-center my-5">Loading...</p>;

  if (!article) {
    return (
      <div className="container my-5">
        <div className="card shadow-sm border-0 p-4">
          <h2 className="text-center" style={{ color: '#FF5733' }}>
            Article Not Found
          </h2>
          <p className="text-center">
            The requested guide does not exist. Please check your URL query parameter (e.g., ?id=1).
          </p>
          <Link to="/news-page" className="btn btn-outline-dark mt-4">
            ← Back to News & Information
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div>
      {/* ---------------- NAVBAR ---------------- */}
     {/* <nav className="navbar navbar-expand-lg navbar-light bg-dark shadow-sm">
        <div className="container">
          <Link to="/" className="navbar-brand">
            <img src="/image/Glogo.png" alt="Company Logo" style={{ height: '50px' }} />
          </Link>
        </div>
      </nav>*/}






      <nav className="navbar navbar-expand-lg navbar-light bg-dark shadow-sm">
              <div className="container">
                <Link to="/" className="navbar-brand">
                  <img
                    src="/image/Glogo.png"
                    alt="Company Logo"
                    style={{ height: '50px', marginRight: '10px' }}
                  />
                </Link>
      
                <button className="navbar-toggler"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#navbarNav"
                  aria-controls="navbarNav"
                  aria-expanded="false"
                  aria-label="Toggle navigation"
                >
                  <span className="navbar-toggler-icon"></span>
                </button>
      
                <div className="collapse navbar-collapse" id="navbarNav">
                  <ul className="navbar-nav ms-auto mx-auto">
                    <li className="nav-item">
                      <Link
                        to="/"
                        className="nav-link text-light"
                        style={{ fontSize: '1.2rem', fontWeight: 'bold' }}
                      >
                        News & Information
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </nav>
      









      {/* ---------------- ARTICLE CONTENT ---------------- */}
      <div className="container my-5">
        <div className="row d-flex align-items-stretch">
          {/* Article Content Section */}
          <div className="col-lg-7 mb-4">
            <div className="card shadow-sm border-0 p-4 h-100">
              <h2 className="text-center mb-4" style={{ color: '#de1829ff' }}>
                {article.title}
              </h2>

              {/* Render article content with HTML */}
              <div
                className="article-body"
                style={{ lineHeight: '1.6' }}
                dangerouslySetInnerHTML={{ __html: article.fullContent }}
              />

              {/* Back to News & Guides Button */}
              <Link to="/news-page" className="btn btn-outline-dark mt-4">
                ← Back to News & Informtion
              </Link>
            </div>
          </div>

          {/* Contact Form Section */}
          <div className="col-lg-5">
            <div className="card shadow-sm border-0 h-100">
              <ContactForm />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ArticleDetailPage;



